"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFxRates = void 0;
const react_1 = __importDefault(require("react"));
const api_1 = __importDefault(require("../api"));
const merlin_hooks_1 = require("@travelnest/merlin-hooks");
const useFxRates = () => {
    const [usd, setUsd] = react_1.default.useState();
    const [eur, setEur] = react_1.default.useState();
    const loading = (0, merlin_hooks_1.useDataLoad)(!usd && !eur, () => Promise.all([
        api_1.default.fx.getFXRateOnDate('GBP', 'USD').then((resp) => setUsd(resp)),
        api_1.default.fx.getFXRateOnDate('GBP', 'EUR').then((resp) => setEur(resp))
    ]));
    return { loadingFxRates: loading, fxRates: { ['GBP:EUR']: eur, ['GBP:USD']: usd } };
};
exports.useFxRates = useFxRates;
//# sourceMappingURL=useFxRates.js.map